import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import Select from "react-select";
import close from "../../assets/icons/close.svg";
import SpinnerLoader from "../../Utils/Spinner";
import { reactSelectStyles } from "../../Utils/selectBoxStyle";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const DraggableRow = ({ fee, index, moveRow, dragDisabled }) => {
  const ref = useRef(null);


  const [, drop] = useDrop({
    accept: "FEE_HEAD",
    hover(item) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;
      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "FEE_HEAD",
    item: { index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });


  // If disabled → DO NOT bind drag/drop
  if (!dragDisabled) {
    drag(drop(ref));
  }

  return (
    <div
      ref={ref}
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 2fr 1fr 40px", // 👈 added 4th column for icon
        padding: "12px",
        marginBottom: "6px",
        border: isDragging ? "2px dashed #7F56DA" : "1px solid #ddd",
        borderRadius: "8px",
        background: isDragging ? "#F4EBFF" : "#fff",
        boxShadow: isDragging
          ? "0px 4px 12px rgba(0,0,0,0.15)"
          : "0px 1px 3px rgba(0,0,0,0.08)",
        transform: isDragging ? "scale(1.02)" : "scale(1)",
        transition: "all 0.15s ease",
        // cursor: "grab",
        cursor: dragDisabled
          ? "default"        // normal cursor when dragging is disabled
          : isDragging
            ? "grabbing"     // while dragging
            : "grab",        // when hover draggable

        opacity: isDragging ? 0.8 : 1,
      }}
    >
      <div>{fee.semesterName}</div>
      <div>{fee.feeName}</div>
      <div style={{ textAlign: "right" }}>₹ {fee.amount}</div>
      <div className="d-flex justify-content-center align-items-center">
        {/* Drag icon column */}
        {/* <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#000000"
          width="28"
          height="28"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><line x1="32" y1="8" x2="32" y2="56"></line><line x1="56" y1="32" x2="8" y2="32"></line><polyline points="40 16 32 8 24 16"></polyline><polyline points="24 48 32 56 40 48"></polyline><polyline points="48 40 56 32 48 24"></polyline><polyline points="16 24 8 32 16 40"></polyline></g></svg> */}
      </div>
    </div>


  );
};

export const CourseWiseFeePlanView = ({
  isOpen,
  onClose,
  courseWiseFeePlan,
  isLoadingCoursePlan,
}) => {
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [semesterFeeHeads, setSemesterFeeHeads] = useState([]);
  const [dragDisabled, setDragDisabled] = useState(false);

  const flattenedFeeHeads = useMemo(() => {
    if (!courseWiseFeePlan) return [];

    const flatHeads = [];
    const idsSet = new Set();

    courseWiseFeePlan.forEach(course => {
      course.fee_heads.forEach(fee => {
        fee.academic_group_fee_plans.forEach(plan => {
          // If selectedSemester is null, include all plans
          if (!selectedSemester || plan.academic_group_id === selectedSemester.value) {
            const uniqueId = `${fee.id}_${plan.id}`;
            if (!idsSet.has(uniqueId)) {
              idsSet.add(uniqueId);
              flatHeads.push({
                id: uniqueId,
                feeName: fee.fee_type_head,
                amount: plan.amount,
                semesterName: (plan.academic_group_name.match(/Semester \d+/) || [plan.academic_group_name])[0],

              });
            }
          }
        });
      });
    });

    return flatHeads;
  }, [courseWiseFeePlan, selectedSemester]);

  console.log("seleted semester", courseWiseFeePlan)

  useEffect(() => {
    // Disable drag drop automatically when semester changes
    setDragDisabled(true);

    // Re-enable after 300ms (optional) → if you want temporary disable
    // setTimeout(() => setDragDisabled(false), 300);

  }, [selectedSemester]);




  useEffect(() => {
    setSemesterFeeHeads(flattenedFeeHeads);
  }, [flattenedFeeHeads]);

  const moveRow = useCallback((fromIndex, toIndex) => {
    setSemesterFeeHeads(prev => {
      const updated = [...prev];
      const [moved] = updated.splice(fromIndex, 1);
      updated.splice(toIndex, 0, moved);
      return updated;
    });
  }, []);

  const handleClose = () => {
    setSelectedSemester(null);
    setSemesterFeeHeads([]);
    onClose();
  };

  // Semester options
  const semesterOptions = useMemo(() => {
    if (!courseWiseFeePlan) return [];
    const setSem = new Set();
    courseWiseFeePlan.forEach(course => {
      course.fee_heads?.forEach(head => {
        head.academic_group_fee_plans?.forEach(plan => {
          setSem.add(JSON.stringify({
            value: plan.academic_group_id,
            label: plan.academic_group_name,
          }));
        });
      });
    });
    return Array.from(setSem).map(s => JSON.parse(s));
  }, [courseWiseFeePlan]);

  const totalSemesterAmount = useMemo(() => {
    if (!flattenedFeeHeads || flattenedFeeHeads.length === 0) return 0;

    return flattenedFeeHeads.reduce((sum, fee) => sum + (fee.amount || 0), 0);
  }, [flattenedFeeHeads]);

  useEffect(() => {
    if (isOpen && semesterOptions.length > 0) {
      setSelectedSemester(semesterOptions[0]);
    }
  }, [isOpen, semesterOptions]);

  return (
    <div className="modal-overlay" style={{ display: isOpen ? "flex" : "none" }}>
      <div
        className="modal-content"
        style={{
          width: "50vw",
          maxHeight: "70vh",
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
          <h2 className="main-heading mb-0" style={{ fontSize: '20px' }}>Course Wise Fee Plan</h2>
          <button onClick={handleClose} style={{ background: "none", border: "none" }}>
            <img src={close} alt="close" />
          </button>
        </div>
        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-md-6">
            <Select
              options={semesterOptions}
              value={selectedSemester}
              onChange={setSelectedSemester}
              isClearable
              placeholder="Select semester..."
              styles={reactSelectStyles}
            />
          </div>
          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <strong>Total Amount: </strong> ₹ {totalSemesterAmount.toFixed(2)}
          </div>
        </div>


        <DndProvider backend={HTML5Backend}>
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(70vh - 180px)",
              marginTop: 12,
              display: "flex",
              flexDirection: "column",
            }}
            className="individualStudentContainer"
          >
            {isLoadingCoursePlan && <SpinnerLoader />}
            {!isLoadingCoursePlan && semesterFeeHeads.length === 0 && (
              <div style={{ padding: 16, textAlign: "center" }}>No fee heads found.</div>
            )}

            {semesterFeeHeads.map((fee, index) => (
              <DraggableRow key={fee.id} fee={fee} index={index} moveRow={moveRow} dragDisabled={dragDisabled} />
            ))}
          </div>
        </DndProvider>
      </div>
    </div>
  );
};
